import {RemoteConstantsModel, UnitData, UnitUpgradeStat, UnitUpgradeTrack} from '../models/remoteConstants.model';

// The unit's type ids: its attributes resolved from metadata uid to id (an id authored directly stays).
export function unitTypeIds(state: RemoteConstantsModel, unit: UnitData): Set<string> {
    const idByUid = new Map((state.unitAttributes ?? []).map(m => [m.uid, m.id]));
    return new Set((unit.attributes ?? []).map(a => idByUid.get(a) ?? a));
}

// Rift.Sim.SimUpgrades.HasType, from the unit's data: only a unit authored with the type takes part.
export function hasType(state: RemoteConstantsModel, unit: UnitData, unitType: string): boolean {
    return unitTypeIds(state, unit).has(unitType);
}

// The active units a track of this type and stat improves. Rift.Sim.SimUpgrades.TakesStat: an attack track
// skips a unit with no attack of its own (it never attacks).
export function unitsOfType(state: RemoteConstantsModel, unitType: string, stat?: UnitUpgradeStat): UnitData[] {
    return (state.units ?? []).filter(u => u.active !== false && hasType(state, u, unitType)
        && (stat !== 'attack' || (u.properties?.attack ?? 0) > 0));
}

export interface TrackTotals {
    levels: number;
    price: number;
    turns: number;
    amount: number;
}

// What researching every level of the track costs and gives.
export function trackTotals(track: UnitUpgradeTrack): TrackTotals {
    return (track.levels ?? []).reduce<TrackTotals>((t, l) => ({
        levels: t.levels + 1,
        price: t.price + (l.price ?? 0),
        turns: t.turns + (l.turns ?? 0),
        amount: t.amount + (l.amount ?? 0),
    }), {levels: 0, price: 0, turns: 0, amount: 0});
}
